module.exports = __webpack_public_path__ + "static/img/banner-title.26811f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-title.png
// module id = vV7T
// module chunks = 0